import React from 'react';

interface AboutUsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const AboutUsModal: React.FC<AboutUsModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black/70 z-[60] flex items-center justify-center p-4" onClick={onClose}>
      <div 
        className="bg-navy-blue p-8 rounded-lg shadow-2xl w-full max-w-3xl relative text-light-blue max-h-[90vh] overflow-y-auto" 
        onClick={(e) => e.stopPropagation()}
        style={{ scrollbarWidth: 'thin', scrollbarColor: '#415A77 #1B263B' }}
      >
        <button onClick={onClose} className="absolute top-4 right-4 text-light-blue hover:text-off-white text-3xl font-light z-10">&times;</button>
        
        <div>
          <h2 className="text-3xl font-bold mb-4 text-off-white">About Us</h2>
          
          <p className="mt-4">
            Welcome to the BTC Gain & Loss Calculator, your go-to tool for effortlessly tracking your Bitcoin investments. We created this platform with a simple goal: to provide a clean, powerful, and user-friendly interface for both new and experienced crypto enthusiasts.
          </p>

          <h3 className="text-xl font-bold mt-6 mb-2 text-off-white">Our Mission</h3>
          <p>
            Our mission is to demystify cryptocurrency investment tracking. We believe that everyone should have access to high-quality tools that provide clarity and insight into their financial positions. By offering real-time data and intuitive features, we aim to empower you to make more informed decisions.
          </p>

          <h3 className="text-xl font-bold mt-6 mb-2 text-off-white">Key Features</h3>
          <ul className="list-disc pl-5 space-y-2 mt-2">
            <li>
              <strong>Real-Time Price Data:</strong> We stream live price updates for BTC in both USD and EUR, so you always have the most current information.
            </li>
            <li>
              <strong>Gain & Loss Calculator:</strong> Easily calculate your potential profits or losses, including an optional field for capital gains tax, to get a complete picture of your investment.
            </li>
            <li>
              <strong>Historical Price Charts:</strong> Analyze Bitcoin's performance over various timeframes with our interactive and detailed price charts.
            </li>
            <li>
              <strong>Custom Price Alerts:</strong> For signed-in users, set personalized browser notifications to alert you when Bitcoin reaches a specific price target.
            </li>
          </ul>

          <p className="mt-6">
            Thank you for using our calculator. We are continuously working to improve the platform and add new features.
          </p>
        </div>
        
        <div className="text-right mt-8 pt-4 border-t border-steel-blue">
            <button
              onClick={onClose}
              className="px-6 py-2 rounded-lg bg-btc-orange text-dark-blue hover:bg-orange-400 transition-colors font-semibold"
            >
              Close
            </button>
        </div>
      </div>
    </div>
  );
};

export default AboutUsModal;